import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ArrowRight, Download } from 'lucide-react';
export function AdmissionBanner() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="admission" className="pt-4 pb-10 bg-white" data-id="element-63">
      <div ref={ref} className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="rounded-2xl p-8 md:p-10 text-center bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/tyt5NKJYZCZ4rdka9mGwt8/t1-bg-1.jpg)'
      }} data-id="element-65">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3 leading-tight" data-id="element-66">
            Admissions Open 2026
          </h2>
          <p className="text-base md:text-lg text-white/90 mb-6 max-w-2xl mx-auto" data-id="element-67">
            Join the MDIC family and embark on a journey of academic excellence
            and personal growth
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-68">
            <a href="#" className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold/90 text-white px-6 py-3 rounded-lg font-semibold transition-all shadow-lg hover:shadow-xl" data-id="element-69">
              Apply Now
              <ArrowRight size={18} data-id="element-70" />
            </a>
            <a href="#" className="inline-flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white px-6 py-3 rounded-lg font-semibold transition-all border border-white/30" data-id="element-71">
              <Download size={18} data-id="element-72" />
              Download Prospectus
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}